import { render, staticRenderFns } from "./paya-report-table.vue?vue&type=template&id=2f2ca3b4"
import script from "./paya-report-table.vue?vue&type=script&lang=js"
export * from "./paya-report-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports